import React, { Component } from 'react';
import './phone.css'
import   SideNav from "./../../component/sidenav/sidenav.js"
import  Payers from "./payees"
import  AuthService  from "../api/authentication.js";
import  Moble from "./../../component/sidenav/moble.js"

const Auth = new AuthService();
const Modal = ({ children, closeModal, modalState, title }) => {
    if(!modalState) {
      return null;
    }
    
    return(
     
        <div className="modal is-active">
          <div className="modal-background" onClick={closeModal}></div>
           <div className="modal-card">
            <header className="modal-card-head">
            <p className="modal-card-title">{title}</p>
            <button className="delete" aria-label="close" onClick={closeModal}></button>
            </header>
            <section className="modal-card-body">
            {children}
            </section>
            <footer className="modal-card-foot">
            <button className="button is-success">Save changes</button>
            <button className="button" onClick={closeModal}>Cancel</button>
            </footer>
           </div>
        </div>
    );
  }
  
//   Modal.propTypes = {
//     closeModal: React.PropTypes.func.isRequired,
//     modalState: React.PropTypes.bool.isRequired,
//     title: React.PropTypes.string
//   }

class  Phone extends Component {


   
    constructor(props) {
        super(props);
        
        this.state = {
          modalState: false,
          witchForm : false,
          payees :[],
          loading:false,
          loadingpayad: true,
          noerorrpage :  true
        };
        
        this.toggleModal = this.toggleModal.bind(this);
      }


      componentWillMount(){
        this.props.noerorrpage(this.state.noerorrpage)
        this.setState({
            noticepop : false,
            loading :false,
            loadingpayad :true
        })
        console.log("get payment",  Auth.getProfile().userId)
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
        };
        fetch("https://uvunebeta.herokuapp.com/payer?payee="+Auth.getProfile().userId, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                console.log("res===================", result)
                this.setState({
                     loading :true,
                    payees : result.data
                })
            }else{
                this.setState({
                  loading   :false
                }) 
            }
        })
        console.log(" payees================", this.state. payees)
        // this.props.checkUsercodition(this.checkUsers())
   
        // console.log("users  condition ===", this.checkUsers())
      }


      addPhone=(e)=>{
        e.preventDefault();
        console.log("judge")
        this.setState({
          loadingpayad :false
        }) 
        
        const data ={
          phone:this.phone.value,
          payee :this.props.user._id,
         }
         console.log("data", data)
         const requestOptions = {
          method: 'POST', 
          headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
          body: JSON.stringify(data),
        };
        console.log("requestOptions", requestOptions)
        fetch("https://uvunebeta.herokuapp.com/payer", requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
              const payees  = this.state.payees
            
              payees.push({
                        phone : this.phone.value,  
                        createdAt: result.createdAt,
                        _id : result._id
                    })
                console.log("res", result)
                this.setState({
                  loadingpayad:true, 

                })
            }else{
                this.setState({
                  loadingpayad :false
                }) 
            }
            this.phone.value = ""
        })
      }

      editpeyer=(data)=>{
        // e.preventDefault();
            console.log("edit" ,data)
            
            const dataedit ={ 
              phone   : data.phone,
              }

          const requestOptions = {
              method: 'PATCH', 
              headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
              body: JSON.stringify(dataedit),
            };

            console.log("data", requestOptions)
            fetch("https://uvunebeta.herokuapp.com/payer/" + data.id, requestOptions)
            .then(res => res.json())
            .then((result)=>{
              if(result){
                  console.log("result", result)
                  this.setState({
                      loadingedit:true,
                      noticeshow : true,
                      noticeMassage : "Updated"
                  })
                  this.timeout() 
              }
            }).catch( (error) => {
              //  console.log("errro", error);
              console.log("error load", error )
          });

          this.setState({
              
              loadingedit:false,
              noticeMassage : "Failed to Update"
          })  
      }


      onDelete = (data) => {
        const requestOptions = {
            method: 'DELETE', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            // body: JSON.stringify(dataedit),
          };
        console.log("dalete", data)
        fetch("https://uvunebeta.herokuapp.com/payer/"+ data, requestOptions)
          .then(res => res.json())
          .then((result)=>{
            if(result){
                console.log("result", result)
                this.setState({
                    loadingedit:true,
                    noticeshow : true,
                    noticeMassage : "Delete"
                })
                this.timeout() 
                const   payees  = this.state.payees
                const fitlereddata =    payees.filter(  pay =>{
                    return  pay._id !== data
                  })
                console.log(fitlereddata)
                this.setState({payees:fitlereddata})
            }
          }).catch( (error) => {
            //  console.log("errro", error);
             console.log("error load", error )
        });

        this.setState({
            // loading:false ,
            noticeMassage : "Failed to Delete"
        })  
    }

      switchformoff = (e)=>{
        e.preventDefault();
        console.log("clicke")
        this.setState({
          witchForm : false
        })
      }

      switchForm0n = (e)=>{
        e.preventDefault();
        console.log("clicke")
        this.setState({
          witchForm : true
        })
      }
      
      toggleModal() {    
        this.setState((prev, props) => {
          const newState = !prev.modalState;
          
          return { modalState: newState };
        });
      }

      timeout() {
        setTimeout(function() {
            this.setState({
                noticeshow : false
            })
          console.log(this.state.noticeshow);
        }.bind(this), 4000);
    }
      
      render() {
        return(
            
         <div className="Phone">
               <div className="Activity-moble-nav-body">
                    < Moble  logout={this.logout}/>
               </div>    
         
         <SideNav vanImage={this.props.user.image_url}  email={this.props.user.email} logout={this.logout} name={this.props.user.display_name} /> 
                
                <div className="main">

                      <div className="more-setting-body"> 
                          <div className="title-phoneAddhead"> Parent  Registration  </div>
                          
                          <div className="columns">
                            <div className="column is-half">
                              <div>
                               <br/>
                               {
                                    this.state.payees.length > 0 ? (
                                      <ul className="responsive-table">
                                 
                                      <li className="table-header">
                                        <div className="col col-1">Phone</div>
                                        <div className="col col-2"> Name</div>
                                        <div className="col col-3"> </div>
                                      </li>
                                        { this.state.loading  ?
                                            <div>
                                                 {
                                               this.state. payees.map( pay=>{
                                                            
                                                  return(
                                                      <Payers 
                                                         key={ pay._id}
                                                         phone={pay.phone}
                                                         name={pay.name}
                                                         editpeyer={this.editpeyer}
                                                         onDelete={this.onDelete}
                                                          id={pay._id}
    
                                                      />
                                                  )
    
                                                })  
                                            }
                                            </div>
                                          :
                                            <div>
                                                <div className="level-item">
                                                    <a className="button is-loading is-large is-light">Loading</a>
                                                </div>  
                                                <br/>
                                            </div>
                                        }
                                     
                                     
                                     
                                    </ul>
                                    ):
                                    (<p>No Registration</p>)

                               }
                            
                              </div>
                            </div>
                            
                            <div className="column is-half">
                              
                              {
                                this.state.witchForm ? 
                                  <div> 
                                     <div className="phone-info-body">
                                        <p ><small>ADD PARENT NUMBER IN multiple WITH CSV </small></p>
                                     </div>
                                     <div className="info-sub">
                                          <input
                                              type="file"
                                              // ref={(input) => { this.filesInput = input }}
                                              name="file"
                                              icon='file text outline'
                                              // iconPosition='left'
                                              label='Upload CSV'
                                              // labelPosition='right'
                                              placeholder='UploadCSV...'
                                              onChange={this.handleChange}
                                            />
                             <a className="button is-success is-rounded">Submit</a> |   <a className="button is-info is-rounded" onClick={this.switchformoff}>Which to Input</a>
                                         
                                        </div>
                                    </div>
                                  :
                                  <div>
                                      <div className="phone-info-body">
                                          <p ><small>ADD PARENT NUMBER  </small></p>
                                              <div className="info-sub">
                                              <form onSubmit={this.addPhone} >
                                                  <div className="field">
                                                          <p className="control has-icons-left has-icons-right">
                                                              <input
                                                              // onChange={this.upDatenote}
                                                               ref={ input => this.phone = input} 
                                                              className="input" type="tel" 
                                                               placeholder="Phone / 09048746464"/>
                                                              <span className="icon is-small is-left">
                                                              <i className="fas fa-phone"></i>
                                                              </span>
                                                          </p>
                                                    </div>
                                                {
                                                this.state.loadingpayad ?
                                                      <div>
                                                           <button className="button is-success is-rounded">Submit</button> |  <a onClick={this.switchForm0n} className="button is-info is-rounded">switch to CSV</a>
                                                      </div>
                                                     
                                                      
                                                  :
                                                   <div className="level-item">
                                                        <a className="button is-loading is-large is-light">Loading</a>
                                                    </div> 
                                                
                                                }
                                                  
                                                  
                                                 
                                              
                                               
                                            </form>       
                                              </div>
                                    </div> 
                                  </div>
                              }
                               
                              <br/>
                               
                            </div>    
                          </div>
                      </div>    
                   {/*                 
                    <div className="has-text-centered content">
                            <h1 className="title">React + Bulma modal example</h1>
                            <hr />
                            <a className="button is-primary" onClick={this.toggleModal}>
                            Open Modal
                            </a>
                    </div>
                     */}


                        <Modal 
                            closeModal={this.toggleModal} 
                            modalState={this.state.modalState} 
                            title="Example modal title">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas sit amet justo in arcu efficitur malesuada nec ut diam. Aenean a iaculis eros. Proin nec purus congue, rutrum sapien id, sodales ante. Nam imperdiet sapien pretium leo dapibus euismod. Ut ac venenatis nunc. Praesent viverra purus vel lacus ullamcorper porta a a augue. Proin rhoncus tempus leo sed ultricies. In luctus aliquam placerat. Cras efficitur enim vitae vulputate consequat. Nulla tellus est, fringilla quis nisi eu, aliquam finibus eros.</p>
                            <p>Aliquam est dui, varius eu tempor ac, ornare vel magna. Suspendisse potenti. Nullam gravida fermentum turpis, at ultricies risus bibendum sit amet. Nulla et arcu id nisi semper ullamcorper cursus sed magna. Phasellus pulvinar ligula vehicula consequat sagittis. Donec tristique tellus sed ex euismod ullamcorper. Vivamus nibh metus, scelerisque sed lorem eget, auctor lobortis sapien. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin congue auctor diam, efficitur dignissim neque. Pellentesque vitae odio ut odio auctor feugiat. Curabitur eget mauris nibh. Vestibulum massa nunc, iaculis at purus venenatis, mollis tincidunt tortor.</p>
                        </Modal>
                    </div>
          </div> 
        );
      }
      
}   

export default Phone;




// WEBPACK FOOTER //
// ./src/component/phone/phone.js